<template>
  <div>
    <Breadcrumb msg1="报表中心" msg2="诊疗量统计" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 15px">
        <el-col :span="6">
          <el-date-picker v-model="dates" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="getData">统计</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border size="small">
        <el-table-column label="日期" prop="date" width="140"></el-table-column>
        <el-table-column label="预约数" prop="appointmentCount" width="120"></el-table-column>
        <el-table-column label="分诊数" prop="triageCount" width="120"></el-table-column>
        <el-table-column label="验光数" prop="optometryCount" width="120"></el-table-column>
        <el-table-column label="问诊数" prop="consultCount" width="120"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      dates: [],
      list: []
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      const params = {}
      if (this.dates && this.dates.length === 2) {
        params.start_date = this.dates[0]
        params.end_date = this.dates[1]
      }
      this.$axios.http.get('/reports/visits', { params: params }).then(r => {
        if (r.data.status === 200) this.list = r.data.data || []
      })
    }
  }
}
</script>
